import WidgetContainer from "compid/shared/containers/WidgetContainer";
import React from "react";
import "./styles.css";

export default function RequestEBillWidget(props){
  const title = props.title ?? "";
  const className = props.className ?? "";
  return(
    <div className={`request-ebill-widget ${className}`}>
      <WidgetContainer>
        <h4>{title}</h4>
        {props.children}
      </WidgetContainer>
    </div>
  );
}